import { services } from '../services';
var action = "payment";
/* eslint-disable no-console */
export const paymentService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    getPay,
    addPay,
    getReceipt,
    getPaidByProperty
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function getPay(id) {
    return services.restApi(`${action}/getpay/${id}`, 'GET');
}
function getReceipt(id) {
    return services.restApi(`${action}/getreceipt/${id}`, 'GET');
}
function getPaidByProperty(id) {
    return services.restApi(`${action}/property/${id}`, 'GET');
}
function addPay(object) {
    return services.restApi(`${action}/addpay`, 'POST', object);
}
function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/remove/${id}`, 'GET');
}
